// extracted by mini-css-extract-plugin
module.exports = {"container":"Accordion_container__6NT_G","label":"Accordion_label__tO6Rb","menuItem":"Accordion_menuItem___atOd","chevronUpIcon":"Accordion_chevronUpIcon__sxHMP"};